import Lang from '/@/modules/core/app/services/Lang';
import Enum from '/@/modules/core/app/helpers/Enum';

export class FuneralPreArrangementCategoryType extends Enum {
  static FUNERAL_HOME = {
    key: 'funeral_home',
    get value() {
      return Lang.t('asset.funeral-home');
    }
  };

  static CEMETERY_PROPERTY = {
    key: 'cemetery_property',
    get value() {
      return Lang.t('asset.cemetery-property');
    }
  };
}
